import styled, { css } from 'styled-components';
import { layout, media } from '@prisjakt/ui-base';

const CARD_MIN_WIDTH = 210;

type ListProps = {
  $active: boolean;
  $columns: number;
  $count: number;
};

export const StyledList = styled.div<ListProps>(
  props => css`
    display: grid;
    grid-template-columns: repeat(
      ${props.$columns},
      minmax(${CARD_MIN_WIDTH}px, 1fr)
    );
    column-gap: ${layout.measurements.spacing100};
    row-gap: ${layout.measurements.spacing100};

    ${media.mediumDown` 
    grid-template-columns: repeat(
      auto-fit,
      minmax(${CARD_MIN_WIDTH}px, 1fr)
    );
    
      ${!props.$active &&
        css`
          grid-auto-flow: column;
          grid-auto-columns: minmax(${CARD_MIN_WIDTH}px, 1fr);
          overflow-x: auto;
          margin: 0 -${layout.measurements.spacing100};
          padding: ${layout.measurements.spacing050}
            ${layout.measurements.spacing100};
        `}
    
  `};

    ${media.mediumOnly`
      ${props.$count === 1 &&
        css`
          grid-template-columns: ${CARD_MIN_WIDTH}px;
        `}
  `}

    ${media.smallOnly`
      ${props.$active &&
        props.$count === 1 &&
        css`
          grid-template-columns: 1fr;
        `}
  `}
  `
);
